import { useState } from "react"
import { FormInputText } from "../input/form-input-text"
import { FormModal } from "./form-modal"

export interface EntityDetails {
    name: string
    abbreviation: string
    bucketName: string
    domains: string
}

interface AddEntityModalProps {
    onAddEntity: (entityDetails: EntityDetails) => void
    onCloseModal: () => void
    triggerMissingRequiredFields: () => void
    triggerErrorMsg: (txt: string) => void
}

export const AddEntityModal: React.FC<AddEntityModalProps> = (
    { onAddEntity, onCloseModal, triggerMissingRequiredFields, triggerErrorMsg }
) => {
    const [entityDetails, setEntityDetails] = useState<EntityDetails>({ name: '', abbreviation: '', bucketName: '', domains: '' })
    const [isShowSpinner, setIsShowSpinner] = useState(false)

    const onChangeFormValue = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value } = event.target
        setEntityDetails({ ...entityDetails, [name]: value })
    }

    const onAdd = async () => {
        if (!entityDetails.name || !entityDetails.abbreviation || !entityDetails.bucketName) {
            return triggerMissingRequiredFields()
        }

        setIsShowSpinner(true)
        try {
            await onAddEntity(entityDetails)
        } catch {
            triggerErrorMsg('Failed creating entity')
        } finally {
            setIsShowSpinner(false)
        }
    }

    return <FormModal
        header="Create Entity"
        onCloseModal={onCloseModal}
        actionBtnText="Create"
        onActionBtn={onAdd}
        isShowSpinner={isShowSpinner}
    >
        <div className="form-section-card">
            <div className="field">
                <FormInputText
                    label="Name"
                    keyName="name"
                    isRequired={true}
                    value={entityDetails.name}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Abbreviation"
                    keyName="abbreviation"
                    isRequired={true}
                    value={entityDetails.abbreviation}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Bucket Name"
                    keyName="bucketName"
                    isRequired={true}
                    value={entityDetails.bucketName}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Domains"
                    keyName="domains"
                    isRequired={false}
                    value={entityDetails.domains}
                    onChange={onChangeFormValue}
                />
            </div>
        </div>
    </FormModal>
}
